<div class="mm-404">
    <div class="container">
        <div class="mm-404-inner">
            <div class="mm-404-code">404</div>
            <h1 class="mm-404-title">
                {{ (lang.lang$ | async) === 'ar' ? 'الصفحة غير موجودة' : 'Page Not Found' }}
            </h1>
            <p class="mm-404-text">
                {{ (lang.lang$ | async) === 'ar'
                    ? 'عذرًا، الصفحة التي تبحث عنها غير موجودة أو ربما تم نقلها.'
                    : 'Sorry, the page you are looking for doesn\'t exist or may have been moved.' }}
            </p>
            <div class="mm-404-actions">
                <a routerLink="/index" class="mm-404-btn">
                    <i class="fa fa-home"></i>
                    {{ (lang.lang$ | async) === 'ar' ? 'العودة إلى الرئيسية' : 'Back to Home' }}
                </a>
                <a routerLink="/company/contact" class="mm-404-btn mm-404-btn-ghost">
                    {{ (lang.lang$ | async) === 'ar' ? 'تواصل معنا' : 'Contact Us' }}
                    <i class="fa fa-long-arrow-right"></i>
                </a>
            </div>

            <div class="mm-404-links">
                <span class="mm-404-links-label">{{ (lang.lang$ | async) === 'ar' ? 'روابط مفيدة:' : 'Popular pages:' }}</span>
                <a routerLink="/itsolutions/services">{{ (lang.lang$ | async) === 'ar' ? 'الخدمات' : 'Services' }}</a>
                <a routerLink="/itsolutions/portfolio/1">{{ (lang.lang$ | async) === 'ar' ? 'أعمالنا' : 'Our Work' }}</a>
                <a routerLink="/itblogs/blogs/grid">{{ (lang.lang$ | async) === 'ar' ? 'الأخبار' : 'News' }}</a>
                <a routerLink="/company/about">{{ (lang.lang$ | async) === 'ar' ? 'من نحن' : 'About' }}</a>
            </div>
        </div>
    </div>
</div>
